<script>
import { mapGetters, mapActions } from 'vuex'
import * as userMutations from '@/store/modules/users/mutations'
import Roles from '@/mixins/Roles'
import TabBase from './tabs/Base'
import TabCars from './tabs/Cars'
import TabCompanies from './tabs/Companies'
import TabAttachments from './tabs/Attachments'
import TabRoles from './tabs/Roles'
import TabServices from './tabs/Services'
export default {
    name: 'UserView',

    components: {
        TabBase,
        TabCars,
        TabCompanies,
        TabAttachments,
        TabRoles,
        TabServices,
    },

    mixins: [Roles],

    computed: mapGetters({ user: 'user', authUser: 'authUser' }),

    watch: {
        $route: {
            handler(newVal, oldVal) {
                if (
                    newVal &&
                    oldVal &&
                    typeof oldVal === 'object' &&
                    typeof newVal === 'object' &&
                    newVal.path == oldVal.path
                )
                    return
                else this.fetch(true)
            },
            immediate: true,
        },
    },

    methods: {
        ...mapActions({
            impersonate: 'authImpersonate',
            suspend: 'usersSuspend',
            resume: 'usersResume',
            delUser: 'usersDelete',
        }),

        async fetch(fresh = true) {
            if (fresh)
                this.$store.commit(userMutations.UPDATE_USER, { data: [] })
            this.$store.dispatch('title', this.$t('USERS.VIEW'))
            await this.$store.dispatch('usersFetch', this.$route.params.user)
        },

        changepassword() {
            this.$refs.passwordmodal.open()
        },

        save() {
            this.$store.dispatch('usersModify', this.user)
        },
    },
}
</script>

<template lang="pug">
div(v-if="user && user.id")
    acrm-modify-password(ref="passwordmodal" :user="user.id")
    acrm-top-panel
        .row.p-3
            .col
                .row
                    .col-auto.flex-center-v.align-content-center.justify-content-center
                        acrm-avatar(large :name="user.display_name")
                    .col-auto.flex-center-v
                        acrm-heading(:level="2") {{ user.display_name }}
                    .col-24.col-lg
                        .row
                            .col-auto(v-if="user.balance || user.balance == 0")
                                acrm-heading.mb-0(:level="5") {{ $t('USERS.ACTUAL_BALANCE')}}
                                acrm-balance-enough(:balance="user.balance")
                                acrm-heading.mt-2.font-weight-bold(:level="2") {{ user.balance | toMoney }}
                            .col-auto(v-if="user.last_login_at")
                                acrm-heading.mb-0(:level="5") {{ $t('USERS.LAST_LOGIN')}}
                                | {{ user.last_login_at | toDateTime }}
                            .col-auto(v-if="hasRole('user.passwordmodify') || user.id == authUser.id")
                                a.text-info.flex-center-v(href="#" @click.prevent="changepassword")
                                    icon(name="lock")
                                    | {{ $t('USERS.CHANGE_PASSWORD') }}
            .col-auto
                .text-right
                    acrm-input-button-dropdown(
                        variant="link" icon="more_horiz" no-handle large align-right
                        v-if="hasRole('user.calendars') || hasRole('user.delete') || hasRole('user.suspend') || hasRole('user.impersonate')"
                        )
                        acrm-input-dropdown-item(icon="exit_to_app" @click="impersonate(user.id)" v-if="hasRole('user.impersonate')") {{ $t('USERS.IMPERSONATE') }}
                        acrm-input-dropdown-item(icon="block" @click="suspend(user)" v-if="user.is_enabled && hasRole('user.suspend')") {{ $t('USERS.ACCOUNT_SUSPEND') }}
                        acrm-input-dropdown-item(icon="play_arrow" @click="resume(user)" v-if="!user.is_enabled && hasRole('user.suspend')") {{ $t('USERS.ACCOUNT_RESUME') }}
                        acrm-input-dropdown-item(icon="delete" @click="delUser(user)" v-if="hasRole('user.delete')")  {{ $t('USERS.ACCOUNT_DELETE') }}
                        acrm-input-dropdown-item(icon="file_download" v-if="hasRole('user.calendars')") {{ $t('USERS.ICAL_DOWNLOAD') }}
                        acrm-input-dropdown-item(icon="file_download" v-if="hasRole('user.calendars')") {{ $t('USERS.GOOGLE_DOWNLOAD') }}

    acrm-tabs(:key="`user-${user.id}`")
        acrm-tab(:name="$t('BASE.BASEDATA')" tabKey="base-data")
            tab-base
        acrm-tab(:name="$t('USERS.CARS', { num: user.cars ? user.cars.length : 0 })" tabKey="cars" v-if="hasRole('user.fields.cars')")
            tab-cars
        acrm-tab(:name="$t('USERS.COMPANIES', { num: user.companies ? user.companies.length : 0 })" tabKey="companies" v-if="hasRole('user.fields.companies')")
            tab-companies
        acrm-tab(:name="$t('BASE.ATTACHMENTS')" tabKey="attachments" v-if="hasRole('user.fields.attachments')")
            tab-attachments
        acrm-tab(:name="$t('USERS.PACKETS')" tabKey="packets" v-if="hasRole('user.fields.packets')")
            tab-services
        acrm-tab(:name="$t('USERS.ROLES')" tabKey="roles" v-if="hasRole('user.fields.roles')")
            tab-roles
</template>
